// context/global.js

import { default as storage } from '../util/storage';
import { createStore, createHook } from 'react-sweet-state';
import { applyColors, getUserObj } from '../util';
import "./i18n";

const globalLang = storage.get('global-lang', 'pl');
const globalLight = storage.get('global-light', 0);
const globalSearch = storage.getObject('global-search', '');
const globalSearchType = storage.getObject('global-search-type', 0);
const globalFilter = storage.getObject('global-filter', {});
const globalPrice = storage.getObject('global-price', { from: '', to: '' });
const globalUser = storage.getObject('global-user', getUserObj());
const globalCategory = storage.getObject('global-category', '');
const globalProgress = ({ active: false, value: 0, label: '' });

applyColors(globalUser?.colors);

const GlobalStoreUser = createStore({
  initialState: globalUser,
  actions: {
    setUser: (user) => ({ setState }) => {
      console.log("%csetUser", "color:red", user);
      storage.setObject('global-user', user);
      setState(user);
    },
    setCredit: (credit) => ({ setState, getState }) => {
      const user = getState();
      user.credit = credit;
      storage.setObject('global-user', user);
      setState(user);
    },
    setLoyalty: (loyalty) => ({ setState, getState }) => {
      const user = getState();
      user.loyalty = loyalty;
      storage.setObject('global-user', user);
      setState(user);
    },
  },
});

const GlobalStore = createStore({
  initialState: {
    light: globalLight,
    lang: globalLang,
    category: globalCategory,
    search: globalSearch,
    searchType: globalSearchType,
    filter: globalFilter,
    price: globalPrice,
    progress: globalProgress,
    mobile: false,
  },
  actions: {
    setLight: (light) => ({ setState, getState }) => {
      storage.set('global-light', light);
      setState({ light });
    },
    setLang: (lang) => ({ setState }) => {
      storage.set('global-lang', lang);
      setState({ lang });
    },
    setSearch: (search) => ({ setState }) => {
      setState({ search: ""+ search });
    },
    setCategory: (category) => ({ setState }) => {
      setState({ category });
    },
    setSearchType: (searchType) => ({ setState }) => {
      setState({ searchType });
    },
    setFilter: (filter) => ({ setState, getState }) => {
      const objList = Object.keys(filter).length > 0 ? { ...getState().filter, ...filter } : Object.assign({});

      // remove undefined values
      Object.keys(objList).forEach(key => {
        if (objList[key] === undefined) delete objList[key];
      });

      setState({ filter: objList });

      // console.log("FilterSTORE", getState().filter, filter);
    },
    setPrice: (price) => ({ setState, getState }) => {
      const current = getState().price;
      const next = { ...current, ...price };
      if (current?.from === next.from && current?.to === next.to) return;
      setState({ price: next });
    },
    setMobile: (mobile) => ({ setState }) => {
      setState({ mobile });
    },
    setProgress: (data) => ({ setState, getState }) => {
      setState({ progress: { ...getState().progress, ...data } });
    },
  },
});

export const useGlobalStore = createHook(GlobalStore);
export const useGlobalStoreUser = createHook(GlobalStoreUser);
